import * as React from "react";

import "./format-email.scss";

export const formatEmail = (email) => {
    const indexOf = email.indexOf("@");
    return (
        <span className="email-23q">
            {email.substring(0, indexOf)}
            <span className="at">@</span>
            {email.substring(indexOf+1)}
        </span>
    );
};